import axios from "axios";

// import {
//   decryptData,
//   encryptData,
// } from "../components/Common/encryptAndDecrypt";

const api = axios.create({
  // baseURL: "http://127.0.0.1:8000/",
  // baseURL: "https://api.jslpro.in:4656/",
  baseURL: "https://api.xift.in:4656/",
  headers: {
    "Content-type": "application/json",
  },
});


export default api;
